module.exports = __webpack_public_path__ + "img/doar.65781997.jpg";